import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-email-templates',
    templateUrl: './email-templates.component.html',
    styleUrls: ['./email-templates.component.scss'],
    standalone: false
})
export class EmailTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
